import React, { useState, useEffect } from "react";
import { Table, Empty, Col, Row } from "antd";
import { MenuUnfoldOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import CurrencyFormat from "react-currency-format";
import moment from "moment";
import RequestHandler from "../../util/RequestHandler";
import MonthlyStatusReportTableFilter from "../Filters/MonthlyStatusReportTableFilter";
import { ColumnHelper } from "../../util/TableHelper";
import { odata, queryHelper } from "../Filters/Helper";

const DailyStatusReport = (props) => {
  const defaultQueryData = {
    pageSize: 15,
  };
  const [tableData, setTableData] = useState({
    data: [],
    currencyCode: "TRY",
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );
  const [totalAmount, setTotalAmount] = useState(0);
  const [isDigitStatusFromDate, setIsDigitStatusFromDate] = useState();

  const history = useHistory();

  useEffect(() => {
    setFilterValues();
    getTableData();
  }, [tableDataQueryOptions]);

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });
    RequestHandler.get(`/TenantUserParameter/GetDigitParameter`).then((response) => {
      if (response.success) {
        setIsDigitStatusFromDate(response.data.isDigitStatusFromDate)
      }
    });
    RequestHandler.post(
      `/Reports/GetDailyStatusPlanReports`,
      tableDataQueryOptions.values,
      false
    ).then((response) => {
      const amountTotal = response[0]
        ? ColumnHelper.renderDecimal(response[0]?.accountBalanceTotal)
        : "-";
      setTotalAmount(amountTotal);

      setTableData({
        data: response,
        currencyCode: tableDataQueryOptions.values.currencyCode
          ? tableDataQueryOptions.values.currencyCode
          : "TRY",
        total: response.length,
        loading: false,
      });
    });

    if (props.onFilterChange) {
      props.onFilterChange(tableDataQueryOptions.values);
    }
  };

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
      values: {},
    });
  };

  const onFinishTableFilter = (query, values) => {
    delete values["dateRange"];
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
        values: values,
      };
    });
  };

  const setFilterValues = () => {
    const filterValues = {
      ...tableDataQueryOptions.values,
      skip: tableDataQueryOptions.skip,
      take: tableDataQueryOptions.take,
      current: tableDataQueryOptions.current,
      order: tableDataQueryOptions.order,
      filter: tableDataQueryOptions.filter,
    };
    const queryString = queryHelper.getQueryFromValues(filterValues);
    history.replace({
      pathname: window.location.pathname,
      search: queryString,
    });
  };

  const GoReportDetailFirmPageCollect = (value) => {
    history.push(`report-daily-firm-details/${value}`);
  };

  const GoReportDetailFirmPagePayment = (value) => {
    history.push(`report-daily-firm-details-payment/${value}`);
  };

  const columns = [
    {
      title: "Tarih",
      dataIndex: "transactionDate",
      key: "transactionDate",
      align: "center",
      width: "10%",
      render: (text, record) => {
        return text == null ? " - " : moment(text).format("L");
      },
    },
    {
      title: "Tahsilat Planı",
      dataIndex: "collectPlanTotal",
      key: "collectPlanTotal",
      align: "center",
      width: "10%",
      render: (text, row, index) => {
        if (text === null) {
          return "-";
        } else {
          if (text.toString().includes(".") === true) {
            return (
              <div>
                <CurrencyFormat
                  value={isDigitStatusFromDate ? text : text.toString().split(".")[0]}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
              </div>
            );
          } else {
            return (
              <div>
                <CurrencyFormat
                  value={isDigitStatusFromDate ? text : text.toString().split(".")[0]}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
                 {isDigitStatusFromDate ? ",00" : ""}
              </div>
            );
          }
        }
      },
    },
    {
      title: "Gerçekleşen Tahsilat",
      dataIndex: "collectTotal",
      key: "collectTotal",
      align: "center",
      width: "10%",
      render: (text, row, index) => {
        if (text === null) {
          return "-";
        } else {
          if (text.toString().includes(".") === true) {
            return (
              <div>
                <CurrencyFormat
                  value={isDigitStatusFromDate ? text : text.toString().split(".")[0]}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
              </div>
            );
          } else {
            return (
              <div>
                <CurrencyFormat
                  value={isDigitStatusFromDate ? text : text.toString().split(".")[0]}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
                 {isDigitStatusFromDate ? ",00" : ""}
              </div>
            );
          }
        }
      },
    },
    {
      title: "Kalan Tahsilat",
      dataIndex: "collectMounthTotal",
      key: "collectMounthTotal",
      align: "center",
      width: "10%",
      render: (text, row, index) => {
        if (text === null || text.toString().includes("-") === true) {
          return "-";
        } else {
          if (text.toString().includes(".") === true) {
            return (
              <div>
                <CurrencyFormat
                  value={isDigitStatusFromDate ? text : text.toString().split(".")[0]}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
              </div>
            );
          } else {
            return (
              <div>
                <CurrencyFormat
                  value={isDigitStatusFromDate ? text : text.toString().split(".")[0]}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
                 {isDigitStatusFromDate ? ",00" : ""}
              </div>
            );
          }
        }
      },
    },
    {
      title: "Ödeme Planı",
      dataIndex: "paymentPlanTotal",
      key: "paymentPlanTotal",
      align: "center",
      width: "10%",
      render: (text, row, index) => {
        if (text === null) {
          return "-";
        } else {
          if (text.toString().includes(".") === true) {
            return (
              <div>
                <CurrencyFormat
                  value={isDigitStatusFromDate ? text : text.toString().split(".")[0]}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
              </div>
            );
          } else {
            return (
              <div>
                <CurrencyFormat
                  value={isDigitStatusFromDate ? text : text.toString().split(".")[0]}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
                 {isDigitStatusFromDate ? ",00" : ""}
              </div>
            );
          }
        }
      },
    },
    {
      title: "Gerçekleşen Ödeme",
      dataIndex: "paymentTotal",
      key: "paymentTotal",
      align: "center",
      width: "10%",
      render: (text, row, index) => {
        if (text === null) {
          return "-";
        } else {
          if (text.toString().includes(".") === true) {
            return (
              <div>
                <CurrencyFormat
                  value={isDigitStatusFromDate ? text : text.toString().split(".")[0]}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
              </div>
            );
          } else {
            return (
              <div>
                <CurrencyFormat
                  value={isDigitStatusFromDate ? text : text.toString().split(".")[0]}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
                 {isDigitStatusFromDate ? ",00" : ""}
              </div>
            );
          }
        }
      },
    },
    {
      title: "Kalan Ödeme",
      dataIndex: "paymentMounthTotal",
      key: "paymentMounthTotal",
      align: "center",
      width: "10%",
      render: (text, row, index) => {
        if (text === null || text.toString().includes("-") === true) {
          return "-";
        } else {
          if (text.toString().includes(".") === true) {
            return (
              <div>
                <CurrencyFormat
                  value={isDigitStatusFromDate ? text : text.toString().split(".")[0]}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
              </div>
            );
          } else {
            return (
              <div>
                <CurrencyFormat
                  value={isDigitStatusFromDate ? text : text.toString().split(".")[0]}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
                 {isDigitStatusFromDate ? ",00" : ""}
              </div>
            );
          }
        }
      },
    },
    {
      title: "Tahmini Bakiye",
      dataIndex: "operation",
      width: "1%",
      align: "center",
      render: (text, record) => {
        return record.accountBalanceMonthlyTotal === 0 ? (
          "-"
        ) : (
          <CurrencyFormat
            value={isDigitStatusFromDate ? record.accountBalanceMonthlyTotal : record.accountBalanceMonthlyTotal.toString().split(".")[0]}
            displayType={"text"}
            decimalSeparator={","}
            thousandSeparator={"."}
          />
        );
      },
    },
    {
      title: "Tahsilat Detay",
      dataIndex: "operation",
      width: "1%",
      align: "center",
      render: (text, record) => (
        <a
          onClick={() => {
            GoReportDetailFirmPageCollect(
              record.transactionDate.replace("/", ".").replace("/", ".") +
                "/" +
                tableData.currencyCode
            );
          }}
          style={{ fontSize: "130%" }}
        >
          <MenuUnfoldOutlined />
        </a>
      ),
    },
    {
      title: "Ödeme Detay",
      dataIndex: "operation",
      width: "1%",
      align: "center",
      render: (text, record) => (
        <a
          onClick={() => {
            GoReportDetailFirmPagePayment(
              record.transactionDate.replace("/", ".").replace("/", ".") +
                "/" +
                tableData.currencyCode
            );
          }}
          style={{ fontSize: "130%", color: "red" }}
        >
          <MenuUnfoldOutlined />
        </a>
      ),
    },
  ];
  return (
    <>
      <Row>
        <Col span={24} style={{ textAlign: "end", fontSize: 19 }}>
          Güncel Bakiye : {isDigitStatusFromDate ? totalAmount : totalAmount.toString().split(",")[0]} {tableData.currencyCode}
        </Col>
      </Row>

      <MonthlyStatusReportTableFilter
        data={tableDataQueryOptions.values}
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
        monthly={false}
        extraText="Varsayılan olarak bu günden itibaren 15 gün ve TRY para birimi listelenmektedir."
      />

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey={(_, index) => index}
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>
    </>
  );
};

export default DailyStatusReport;
